import React from 'react';

import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import PageHeader from '../../../components/PageHeader';
import { RouteKey } from '../../../constants/navigation';
import ConnectedBuilderPage from '../ConnectedBuilderPage';

class DescriptionHelp extends React.PureComponent {
    render() {
        return (
            <Page>
                <PageBody>
                    <PageHeader>Describe Your Character</PageHeader>
                    <p>In this step, you will flesh your character out as a person. Your character needs a name.</p>

                    <p>
                        You’ll need to decide your character’s appearance and personality. Choose your character’s
                        alignment (the moral compass that guides his or her decisions) and ideals. Identify the things
                        your character holds most dear, called bonds, and the flaws that could one day undermine him or
                        her.
                    </p>

                    <PageHeader>Background</PageHeader>
                    <p>You will also choose a background in this step.</p>

                    <p>
                        Your character’s background describes where he or she came from, his or her original occupation,
                        and the character’s place in the D&amp;D world.
                    </p>

                    <p>
                        A background gives your character a background feature (a general benefit) and proficiency in
                        two skills, and it might also give you additional languages or proficiency with certain kinds of
                        tools
                    </p>
                </PageBody>
            </Page>
        );
    }
}

export default ConnectedBuilderPage(DescriptionHelp, RouteKey.DESCRIPTION_HELP);
